import { useQuery } from 'react-query';
import { getAccount } from '../api/getAccount';
import { Account } from '../api/getAccount.types';

export const useGetAccount = () => useQuery<Account, Error>('getAccount', getAccount);
